// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#unity-container-overlay {
    position: absolute;
    z-index: 9;
    top: 10px;
    right: 10px;
    pointer-events: auto;

    .unity-overlay-toolbar {
        display: flex;
        align-items: flex-start;
        gap: 5px;
    }

    .unity-overlay-toolbar__column {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        width: 36px;
        border-radius: 5px;
        background: #363636;
    }

    .unity-overlay-toolbar__column--dropdown {
        position: relative;
    }

    .unity-overlay-toolbar__button {
        position: relative;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0;
        border-radius: 5px;
        background: #363636;
        cursor: pointer;
    }

    .unity-overlay-toolbar__button:hover,
    .unity-overlay-toolbar__button:focus-visible,
    .unity-overlay-toolbar__button--active {
        background: #303030;
        color: #ffffff;
        outline: 0;
    }

    .unity-overlay-toolbar__button--dropdown::before {
        content: "";
        position: absolute;
        right: 3px;
        bottom: 3px;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 0 solid transparent;
        border-bottom: 6px solid #777777;
    }

    .unity-overlay-toolbar__icon {
        display: block;
        width: 22px;
        height: 22px;
        object-fit: contain;
    }

    .unity-overlay-toolbar__menu {
        display: none;
        flex-direction: column;
    }

    .unity-overlay-toolbar__column--open .unity-overlay-toolbar__menu {
        display: flex;
    }

    .unity-overlay-toolbar__menu .unity-overlay-toolbar__button {
        border-radius: 0;
    }

    .unity-overlay-toolbar__menu .unity-overlay-toolbar__button:last-child {
        border-radius: 0 0 5px 5px;
    }

    /* "Megjelenítés": the dot on the button while a layer is hidden */
    .unity-overlay-toolbar__badge {
        position: absolute;
        top: 5px;
        right: 5px;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #e6daca;
        box-shadow: 0 0 0 2px #363636;
    }

    /* the menu it opens: a card in the configurator panel's look (UCThemeProvider: Montserrat, the
       primary green #314c3d / #3e5c4b, white paper with a #c0c0c0 border, uppercase 600 headings) */
    .unity-visibility-menu {
        display: none;
        position: absolute;
        top: 41px;
        right: 0;
        min-width: 200px;
        flex-direction: column;
        padding: 8px 0;
        border: 1px solid #c0c0c0;
        border-radius: 8px;
        background: #ffffff;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
        font-family: "Montserrat", sans-serif;
    }

    .unity-overlay-toolbar__column--open .unity-visibility-menu {
        display: flex;
    }

    .unity-visibility-menu__title {
        padding: 2px 14px 8px;
        color: #314c3d;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.02em;
        text-transform: uppercase;
    }

    .unity-visibility-menu__row {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        padding: 7px 14px;
        border: 0;
        background: transparent;
        color: #314c3d;
        font-family: inherit;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.2;
        text-align: left;
        white-space: nowrap;
        cursor: pointer;
    }

    .unity-visibility-menu__row:hover,
    .unity-visibility-menu__row:focus-visible {
        background: rgba(49, 76, 61, 0.08);
        outline: 0;
    }

    /* the three-state box: shown (checked), hidden (empty), partial (a dash) */
    .unity-visibility-menu__box {
        position: relative;
        flex: none;
        width: 18px;
        height: 18px;
        box-sizing: border-box;
        border: 2px solid #314c3d;
        border-radius: 3px;
        background: #ffffff;
    }

    .unity-visibility-menu__row--shown .unity-visibility-menu__box,
    .unity-visibility-menu__row--partial .unity-visibility-menu__box {
        background: #314c3d;
    }

    .unity-visibility-menu__row--shown .unity-visibility-menu__box::after {
        content: "";
        position: absolute;
        left: 4px;
        top: 0;
        width: 5px;
        height: 10px;
        border: solid #ffffff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }

    .unity-visibility-menu__row--partial .unity-visibility-menu__box::after {
        content: "";
        position: absolute;
        left: 2px;
        right: 2px;
        top: 6px;
        height: 2px;
        background: #ffffff;
    }

    .unity-visibility-menu__all {
        margin: 8px 14px 2px;
        padding: 6px 10px;
        border: 1px solid #314c3d;
        border-radius: 4px;
        background: #ffffff;
        color: #314c3d;
        font-family: inherit;
        font-size: 13px;
        font-weight: 600;
        text-transform: uppercase;
        cursor: pointer;
    }

    .unity-visibility-menu__all:hover:not(:disabled) {
        background: rgba(49, 76, 61, 0.08);
    }

    .unity-visibility-menu__all:disabled {
        border-color: #c0c0c0;
        color: #a0a0a0;
        cursor: default;
    }

}`, "",{"version":3,"sources":["webpack://./src/v2/unityView/UnityView.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,oBAAoB;;IAEpB;QACI,aAAa;QACb,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,oBAAoB;QACpB,WAAW;QACX,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;QACT,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;;;QAGI,mBAAmB;QACnB,cAAc;QACd,UAAU;IACd;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,QAAQ;QACR,SAAS;QACT,kCAAkC;QAClC,iCAAiC;QACjC,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA,kEAAkE;IAClE;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,UAAU;QACV,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,6BAA6B;IACjC;;IAEA;oGACgG;IAChG;QACI,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,gBAAgB;QAChB,sBAAsB;QACtB,cAAc;QACd,yBAAyB;QACzB,kBAAkB;QAClB,mBAAmB;QACnB,0CAA0C;QAC1C,qCAAqC;IACzC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,qBAAqB;QACrB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,WAAW;QACX,iBAAiB;QACjB,SAAS;QACT,uBAAuB;QACvB,cAAc;QACd,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;;QAEI,kCAAkC;QAClC,UAAU;IACd;;IAEA,2EAA2E;IAC3E;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,YAAY;QACZ,sBAAsB;QACtB,yBAAyB;QACzB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,MAAM;QACN,UAAU;QACV,YAAY;QACZ,qBAAqB;QACrB,yBAAyB;QACzB,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,QAAQ;QACR,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB,yBAAyB;QACzB,kBAAkB;QAClB,mBAAmB;QACnB,cAAc;QACd,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,qBAAqB;QACrB,cAAc;QACd,eAAe;IACnB;;AAEJ","sourcesContent":["\n#unity-container-overlay {\n    position: absolute;\n    z-index: 9;\n    top: 10px;\n    right: 10px;\n    pointer-events: auto;\n\n    .unity-overlay-toolbar {\n        display: flex;\n        align-items: flex-start;\n        gap: 5px;\n    }\n\n    .unity-overlay-toolbar__column {\n        display: flex;\n        flex-direction: column;\n        align-items: stretch;\n        width: 36px;\n        border-radius: 5px;\n        background: #363636;\n    }\n\n    .unity-overlay-toolbar__column--dropdown {\n        position: relative;\n    }\n\n    .unity-overlay-toolbar__button {\n        position: relative;\n        width: 36px;\n        height: 36px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: 0;\n        border-radius: 5px;\n        background: #363636;\n        cursor: pointer;\n    }\n\n    .unity-overlay-toolbar__button:hover,\n    .unity-overlay-toolbar__button:focus-visible,\n    .unity-overlay-toolbar__button--active {\n        background: #303030;\n        color: #ffffff;\n        outline: 0;\n    }\n\n    .unity-overlay-toolbar__button--dropdown::before {\n        content: \"\";\n        position: absolute;\n        right: 3px;\n        bottom: 3px;\n        width: 0;\n        height: 0;\n        border-left: 6px solid transparent;\n        border-right: 0 solid transparent;\n        border-bottom: 6px solid #777777;\n    }\n\n    .unity-overlay-toolbar__icon {\n        display: block;\n        width: 22px;\n        height: 22px;\n        object-fit: contain;\n    }\n\n    .unity-overlay-toolbar__menu {\n        display: none;\n        flex-direction: column;\n    }\n\n    .unity-overlay-toolbar__column--open .unity-overlay-toolbar__menu {\n        display: flex;\n    }\n\n    .unity-overlay-toolbar__menu .unity-overlay-toolbar__button {\n        border-radius: 0;\n    }\n\n    .unity-overlay-toolbar__menu .unity-overlay-toolbar__button:last-child {\n        border-radius: 0 0 5px 5px;\n    }\n\n    /* \"Megjelenítés\": the dot on the button while a layer is hidden */\n    .unity-overlay-toolbar__badge {\n        position: absolute;\n        top: 5px;\n        right: 5px;\n        width: 7px;\n        height: 7px;\n        border-radius: 50%;\n        background: #e6daca;\n        box-shadow: 0 0 0 2px #363636;\n    }\n\n    /* the menu it opens: a card in the configurator panel's look (UCThemeProvider: Montserrat, the\n       primary green #314c3d / #3e5c4b, white paper with a #c0c0c0 border, uppercase 600 headings) */\n    .unity-visibility-menu {\n        display: none;\n        position: absolute;\n        top: 41px;\n        right: 0;\n        min-width: 200px;\n        flex-direction: column;\n        padding: 8px 0;\n        border: 1px solid #c0c0c0;\n        border-radius: 8px;\n        background: #ffffff;\n        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\n        font-family: \"Montserrat\", sans-serif;\n    }\n\n    .unity-overlay-toolbar__column--open .unity-visibility-menu {\n        display: flex;\n    }\n\n    .unity-visibility-menu__title {\n        padding: 2px 14px 8px;\n        color: #314c3d;\n        font-size: 13px;\n        font-weight: 600;\n        letter-spacing: 0.02em;\n        text-transform: uppercase;\n    }\n\n    .unity-visibility-menu__row {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        width: 100%;\n        padding: 7px 14px;\n        border: 0;\n        background: transparent;\n        color: #314c3d;\n        font-family: inherit;\n        font-size: 14px;\n        font-weight: 500;\n        line-height: 1.2;\n        text-align: left;\n        white-space: nowrap;\n        cursor: pointer;\n    }\n\n    .unity-visibility-menu__row:hover,\n    .unity-visibility-menu__row:focus-visible {\n        background: rgba(49, 76, 61, 0.08);\n        outline: 0;\n    }\n\n    /* the three-state box: shown (checked), hidden (empty), partial (a dash) */\n    .unity-visibility-menu__box {\n        position: relative;\n        flex: none;\n        width: 18px;\n        height: 18px;\n        box-sizing: border-box;\n        border: 2px solid #314c3d;\n        border-radius: 3px;\n        background: #ffffff;\n    }\n\n    .unity-visibility-menu__row--shown .unity-visibility-menu__box,\n    .unity-visibility-menu__row--partial .unity-visibility-menu__box {\n        background: #314c3d;\n    }\n\n    .unity-visibility-menu__row--shown .unity-visibility-menu__box::after {\n        content: \"\";\n        position: absolute;\n        left: 4px;\n        top: 0;\n        width: 5px;\n        height: 10px;\n        border: solid #ffffff;\n        border-width: 0 2px 2px 0;\n        transform: rotate(45deg);\n    }\n\n    .unity-visibility-menu__row--partial .unity-visibility-menu__box::after {\n        content: \"\";\n        position: absolute;\n        left: 2px;\n        right: 2px;\n        top: 6px;\n        height: 2px;\n        background: #ffffff;\n    }\n\n    .unity-visibility-menu__all {\n        margin: 8px 14px 2px;\n        padding: 6px 10px;\n        border: 1px solid #314c3d;\n        border-radius: 4px;\n        background: #ffffff;\n        color: #314c3d;\n        font-family: inherit;\n        font-size: 13px;\n        font-weight: 600;\n        text-transform: uppercase;\n        cursor: pointer;\n    }\n\n    .unity-visibility-menu__all:hover:not(:disabled) {\n        background: rgba(49, 76, 61, 0.08);\n    }\n\n    .unity-visibility-menu__all:disabled {\n        border-color: #c0c0c0;\n        color: #a0a0a0;\n        cursor: default;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
